import styled from "styled-components";

export const Background = styled.div`
  background: linear-gradient(#83b8fe, #ced9f2);
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const Input = styled.input`
  border: 1px solid rgba(252, 252, 252, 0.4);
  width: 250px;
  border-radius: 5px;
  padding: 10px 15px;
  font-size: 18px;
  border: 1px solid black;
  display: inline;
`;

export const Button = styled.button`
  appearance: none;
  outline: 0;
  background-color: blue;
  border: 0;
  padding: 10px 15px;
  color: #ffff;
  border-radius: 5px;
  font-size: 18px;
`;

export const Image = styled.img`
  transform: translateY(-150px);
  position: relative;
  top: 190px;
  margin-right: 80px;
  max-height: 500px;
  float: right;
  @media screen and (max-width: 798px){
    position: relative;
    top: 0px;
    left: 40px;
    transform: translateY(-70px);
  }
  @media screen and (max-width: 414px){
    position: relative;
  }
  @media screen and (max-width: 600px){
    position: relative;
    left: 80px;
    transform: translateY(0px);
  }
  @media screen and (max-width: 480px){
    position: relative;
    top: 0px;
    left: -70px;
    transform: translateY(-70px);
  }
  @media screen and (max-width: 400px){
    position: relative;
    left: 0px;
    transform: translateY(-70px);
  }
  @media screen and (max-width: 375px){
    position: relative;
    margin-right: 40px;
    transform: translateY(-50px);
    max-height: 300px;
    margin-right: 20px;
    float: none;
  }
`;

export const Form = styled.form`
  position: relative;
  padding-top: 140px;
  padding-left: 50px;
`;

export const ContactusColumn1 = styled.div`
	width: calc(50% - (0.5em + 6px));
	float: left;
	min-height: 400px;

	@media screen and (max-width: 768px) {
		width: 80%;
		flex-basis: 100%;
		display: flex;
		justify-content: center;
	}
`;

export const ContactusColumn2 = styled.div`
	width: calc(50% - (0.5em + 6px));
	float: right;
	min-height: 400px;
  padding-top: 130px;
  margin: 0 auto;   

	@media screen and (max-width: 768px) {
		width: 80%;
		flex-basis: 100%;
		display: flex;
		justify-content: center;
    margin: 0 auto;
	}
`;

export const ContacuspageRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	flex-direction: row;
	display: table;
	clear: both;
`;

export const Subtitle = styled.p`
  font-weight: bold;
  max-width: 100%;
  margin-bottom: 15px;
  margin-left: 30px;
  font-size: 24px;
  text-align: left;
  line-height: 2;
  color: #000000;
  word-wrap: break-word;

  @media screen and (max-width: 320px) {
    font-size: 18px; 
    margin-left: 15px;
    max-width: 85%;
  }

  @media screen and (max-width: 360px) {
    font-size: 18px; 
    margin-left: 15px;
    max-width: 85%;
  }

  @media screen and (max-width: 375px) {
    font-size: 18px; 
    margin-left: 30px;
    max-width: 85%;
  }

  @media screen and (max-width: 390px) {
    font-size: 22px; 
    margin-left: 25px;
    max-width: 90%;
  }
`;
